import "@fortawesome/fontawesome-free/css/all.min.css";
import { useState } from "react";

function Webwasa() {
  const [activeTab, setActiveTab] = useState("methodology");

  return (
    <div>
      {/* -- Banner sec ---- */}
      <div className="page-banner-area">
        <h2>Services</h2>
        <div className="breadcrumbs-services">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li> IS Audit </li>
          </ul>
        </div>
      </div>
      {/* -- Banner sec ---- */}

      {/* ---- About service section ----- */}
      <div className="about-services-wrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              {/* headings */}
              <div className="heading-in mb-5">
                <h1>IS Audit</h1>
                <p>
                  <b className="sub-heading">Introduction</b>
                  <br />
                  An Information Systems (IS) Audit is a structured evaluation
                  of your organization’s IT infrastructure, policies, and
                  operations. It ensures that your systems are secure,
                  compliant, and aligned with business objectives, while also
                  validating the integrity, confidentiality, and availability of
                  your data. At [Your Company Name], we perform comprehensive IS
                  Audits that cover IT governance, risk management, controls,
                  and compliance, giving organizations confidence in their
                  digital ecosystem.
                </p>
              </div>
              {/* headings */}

              <div className="service-card-heading">
                <h1>Why It Matters</h1>
              </div>
              <div className="services-cards-wp">
                {[
                  {
                    icon: "fa-arrows-down-to-people",
                    title: "Regulatory Compliance",
                    desc: "Ensure adherence to standards such as ISO 27001, COBIT, SOX, GDPR, IT Act, and RBI/SEBI guidelines.",
                  },
                  {
                    icon: "fa-database",
                    title: "Risk Management",
                    desc: "Identify and mitigate risks related to cybersecurity, system downtime, and data breaches.",
                  },
                  {
                    icon: "fa-shield-halved",
                    title: "Operational Efficiency",
                    desc: "Streamline IT processes for better performance, cost-effectiveness, and reliability.",
                  },
                  {
                    icon: "fa-table",
                    title: "Data Integrity & Security",
                    desc: "Protect critical information assets from unauthorized access, misuse, or corruption.",
                  },
                  {
                    icon: "fa-business-time",
                    title: "Business Assurance",
                    desc: "Ensure IT systems support business continuity and strategic goals.",
                  },
                ].map((item, i) => (
                  <div className="service-box" key={i}>
                    <div className="service-icon">
                      <i className={`fa-solid ${item.icon}`}></i>
                    </div>
                    <div className="service-card-content">
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/*-------- TAB AND PILL SEC ----------- */}
              <div className="tab-pill-sec-main">
                <div className="tab-inner-contain">
                  <ul className="nav nav-pills">
                    {[
                      { id: "methodology", label: "Methodology" },
                      { id: "keybenefits", label: "Key Benefits" },
                      { id: "deliverables", label: "Deliverables" },
                    ].map((tab) => (
                      <li className="nav-item" key={tab.id}>
                        <button
                          className={`nav-link${activeTab === tab.id ? " active" : ""}`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.label}
                        </button>
                      </li>
                    ))}
                  </ul>

                  <div className="tab-content">
                    {/* Methodology */}
                    <div className={`tab-pane fade${activeTab === "methodology" ? " show active" : ""}`} role="tabpanel">
                      <p>Our IS Audit process includes:</p>
                      <ul>
                        <li><b>Planning & Scope Definition :-</b> Understand business objectives, regulatory requirements, and IT environment.</li>
                        <li><b>Governance & Policy Review :-</b> Evaluate IT policies, procedures, and control frameworks.</li>
                        <li><b>Technical Assessment :-</b> Audit infrastructure, applications, networks, and access controls.</li>
                        <li><b>Risk & Compliance Evaluation :-</b> Assess risks against regulatory and industry standards.</li>
                        <li><b>Process & Operations Review :-</b> Assess IT operations, change management, backup, and disaster recovery.</li>
                        <li><b>Security Control Validation :-</b> Verify data protection, encryption, and identity management mechanisms.</li>
                        <li><b>Reporting & Recommendations :-</b> Deliver insights, risk findings, and a remediation roadmap.</li>
                      </ul>
                    </div>

                    {/* Key Benefits */}
                    <div className={`tab-pane fade${activeTab === "keybenefits" ? " show active" : ""}`} role="tabpanel">
                      <ul>
                        <li>Ensure compliance with global and local standards.</li>
                        <li>Improve IT governance and risk management.</li>
                        <li>Enhance cybersecurity posture and resilience.</li>
                        <li>Strengthen operational efficiency and business continuity.</li>
                        <li>Build trust with customers, stakeholders, and regulators.</li>
                      </ul>
                    </div>

                    {/* Deliverables */}
                    <div className={`tab-pane fade${activeTab === "deliverables" ? " show active" : ""}`} role="tabpanel">
                      <p>You will receive:</p>
                      <ul>
                        <li>Comprehensive IS Audit Report</li>
                        <li>Governance & Policy Gap Analysis</li>
                        <li>Risk & Compliance Mapping Report</li>
                        <li>Security & Controls Assessment</li>
                        <li>IT Operations Review Findings</li>
                        <li>Remediation Roadmap with Action Plan</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/*---------- TAB AND PILL SEC ---------- */}

              {/* ------- OUR APPROACH SEC ------ */}
              <div className="our-approach-sec-main">
                <div className="container">
                  <h3>Our Approach </h3>
                  <ul>
                    <li><b>Certified IS Auditors :-</b> Expertise in CISA, ISO, COBIT, ITIL, and regulatory frameworks.</li>
                    <li><b>End-to-End Assessment :-</b> Covering governance, risk, compliance, operations, and security.</li>
                    <li><b>Industry Expertise :-</b> Proven track record across BFSI, healthcare, government, telecom, and IT sectors.</li>
                    <li><b>Global Standards Alignment :-</b> Ensuring compliance with ISO 27001, COBIT 2019, and GDPR.</li>
                    <li><b>Actionable Insights :-</b> Clear, prioritized recommendations to strengthen IT governance and security.</li>
                  </ul>
                </div>
              </div>
              {/* ------- OUR APPROACH SEC ------ */}
            </div>
          </div>
        </div>
      </div>
      {/* ---- About service section ----- */}
    </div>
  );
}

export default Webwasa;
